import { find } from 'lodash';
import { stateName } from './constants';

const localState = state => state[stateName];

export const getUiState = state => localState(state).uiState;
export const getPlacements = state => localState(state).placements;
export const getSegmentIds = state => localState(state).segmentIds;
export const getPlacementByShape = function (shape) {
  let mediation = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
  return state => find(getPlacements(state), {
    shape,
    mediation
  });
};
export const getIsPlacementsPresent = state => !!getPlacements(state).length; // When the first of existing placements has the same page name as the one provided in `page`
// argument of the function - this should return true. This can be used to determine if current
// placements are for the page that triggered `loadAdsPlacements`. If there are no placements
// or if the page name is different - it will return false.

export const getIsPlacementPageMatching = page => state => {
  var _getPlacements$;

  return ((_getPlacements$ = getPlacements(state)[0]) === null || _getPlacements$ === void 0 ? void 0 : _getPlacements$.page) === page;
};
export const getIsPlacementPresent = function (shape) {
  let mediation = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
  return state => !!getPlacementByShape(shape, mediation)(state);
};
export const getIsAdBlockerUsed = state => localState(state).isAdBlockerUsed;
export const getHasAdBlockerBeenTracked = state => localState(state).hasAdBlockerBeenTracked;
export const getAdBlockerVisitorId = state => localState(state).adBlockerVisitorId;